// src/components/dialog/DlgNotificationPoolInfo.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { DlgCloseButton, HStack } from '..'
import { useNotificationPool } from '../../hooks'

type StatRecordProps = {
  label: any
  value: any
}

const StatRecord = ({ label, value, ...rest }: StatRecordProps) => (
  <HStack spacing={2} sx={{ width: 1 }} {...rest}>
    <Stack sx={{ flex: 1, textAlign: 'right' }}>
      <Typography>{label}</Typography>
    </Stack>

    <Stack sx={{ flex: 1, textAlign: 'left' }}>
      <Typography>{value}</Typography>
    </Stack>
  </HStack>
)

const NotificationPoolStat = () => {
  const notificationPool = useNotificationPool()

  return (
    <Stack sx={{ mt: 3 }}>
      <StatRecord label={'Poolgröße'} value={notificationPool.length} />

      {[
        {
          label: 'Verwendung in Gebäuden',
          value: [...new Set(notificationPool.map(i => i.folder_id))].length,
        },
        {
          label: 'Überwachte Sensoren',
          value: [...new Set(notificationPool.map(i => i.sensor_id))].length,
        },
        {
          label: 'E-Mail Topics',
          value: [...new Set(notificationPool.map(i => i.email_topic))].length,
        },
        {
          label: 'Identifiers',
          value: [...new Set(notificationPool.map(i => i.identifier))].length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}
    </Stack>
  )
}

export const DlgNotificationPoolInfo = ({
  onClose,
  open,
}: KARMA_BasicDialog) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>
      <Typography sx={{ fontSize: 20 }}>
        Benachrichtigungen Pool Info
      </Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent>
      <NotificationPoolStat />
    </DialogContent>
  </Dialog>
)
